import { SigLabel } from '../components/atelier';

export function Workflow() {
  return (
    <section id="workflow" className="container section">
      <div className="block-head">
        <div>
          <SigLabel>Where LMcad fits</SigLabel>
          <h2>
            We&rsquo;re the front of the bench.{' '}
            <em>Your CAD is still the bench.</em>
          </h2>
        </div>
        <p className="lede">
          The toolchain doesn&rsquo;t change. We slot in before the first
          serious sketch. That&rsquo;s where most parts get stuck.
        </p>
      </div>

      <div className="workflow">
        <div className="workflow-step">
          <div className="role">
            <em>Step 1</em> · Idea
          </div>
          <h4>A sentence in your head</h4>
          <p>
            &ldquo;A bracket that holds two M6 bolts, fits a 40&nbsp;×&nbsp;40
            extrusion, prints overnight.&rdquo;
          </p>
        </div>

        <div className="workflow-arrow" aria-hidden>
          <svg width="40" height="20" viewBox="0 0 40 20" fill="none">
            <path
              d="M2 10 H34 M28 4 L34 10 L28 16"
              stroke="var(--accent)"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="workflow-step middle">
          <div className="role">
            <em>Step 2</em> · LMcad
          </div>
          <h4>Rapid prototype</h4>
          <p>
            A named-parameter part, a 3D preview, and a clean STEP, ready to
            land in your CAD. Usually a minute. Sometimes thirty seconds.
          </p>
        </div>

        <div className="workflow-arrow" aria-hidden>
          <svg width="40" height="20" viewBox="0 0 40 20" fill="none">
            <path
              d="M2 10 H34 M28 4 L34 10 L28 16"
              stroke="var(--accent)"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="workflow-step">
          <div className="role">
            <em>Step 3</em> · CATIA · Creo · SolidWorks
          </div>
          <h4>The work that ships</h4>
          <p>
            Open the STEP, refine, GD&amp;T, manufacturing prep, assemblies.
            All in the CAD your team already runs.
          </p>
        </div>
      </div>

      <p
        className="muted"
        style={{
          marginTop: 32,
          fontSize: 13,
          fontFamily: 'var(--font-serif)',
          fontStyle: 'italic',
          textAlign: 'center',
        }}
      >
        Same toolchain. New entry point.
      </p>
    </section>
  );
}
